<div class="dds-modal-overlay" (click)="onCancel()"></div>

<div ddsResize class="dds-modal data-table-filter">
  <div class="dds-modal__header">
    <span class="dds-modal__title">{{ title | translate }}</span>
    <button class="dds-modal__close icon-close-default-16" (click)="onCancel()"></button>
  </div>

  <div class="dds-modal__body">
    <ng-content></ng-content>
  </div>

  <div class="dds-modal__footer">
    <div class="dds-modal__footer-content dds-modal__footer-content_left">
      <app-button
        type="button"
        class="dds-modal__footer-item"
        [kind]="'primary'"
        [isDisabled]="!resetEnabled"
        (clicked)="onReset()"
        (keyboardClicked)="onReset()"
        [label]="'Translation.Resetall' | translate"></app-button
      >
    </div>
    <div class="dds-modal__footer-content dds-modal__footer-content_right">
      <app-button
        type="button"
        class="dds-modal__footer-item"
        [kind]="'primary'"
        (clicked)="onCancel()"
        (keyboardClicked)="onCancel()"
        [label]="'Translation.Cancel' | translate"></app-button
      >
      <app-button
        type="button"
        class="dds-modal__footer-item"
        [kind]="'primaryLoud'"
        (clicked)="onApply()"
        [isDisabled]="!applyEnabled"
        (keyboardClicked)="onApply()"
        [label]="'Translation.Apply' | translate"></app-button>
    </div>
  </div>
</div>
